module.exports = __webpack_public_path__ + "static/media/close.f7859e7d.svg";